export const LIST_ITEM_TAG_NAME = 'li';
